var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.comp)?_c('div',[_c(_vm.comp,_vm._b({tag:"component"},'component',{stats: _vm.getStats()},false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }